import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

import { VFab } from 'vuetify/labs/VFab'
import { VTreeview } from 'vuetify/labs/VTreeview'


const customLightTheme = {
    dark: false,
    colors: {
        primary: '#3F51B5',
        primaryF: '#1f2557',
        secondary: '#7986CB',
        iconColorLight:  '#646363',
        accent: '#3D5AFE',
        error: '#EF5350',
        info: '#536DFE',
        success: '#8BC34A',
        warning: '#FFC107',
        tooltip:'#252525',
        primaryFont: '#000',
        toolbarTabsBackground: '#f1f1f1',
    },
    variables: {
        myColor: '#ff0000'
    }
}

export default createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },

    },
    theme: {
        defaultTheme: 'customLightTheme',
        themes: {
            customLightTheme,
        },
    },
    components: {
        VFab,
        VTreeview,
        ...components,
    },

    directives,
})
